import BuildItemType from '../../../BuildItemType'

import botDefaultIconSrc from './botDefaultIcon.svg'
import botSelectedIconSrc from './botSelectedIcon.svg'
import dataDefaultIconSrc from './dataDefaultIcon.svg'
import dataSelectedIconSrc from './dataSelectedIcon.svg'

export const buildItems = [
  {
    name: 'Drift Bots',
    type: BuildItemType.BOT,
    defaultIconSrc: botDefaultIconSrc,
    selectedIconSrc: botSelectedIconSrc
  },
  {
    name: 'Data Integrations',
    type: BuildItemType.DATA_INTEGRATION,
    defaultIconSrc: dataDefaultIconSrc,
    selectedIconSrc: dataSelectedIconSrc
  }
]
